import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldFormComponent } from './field-form.component';
import {DxFormModule} from 'devextreme-angular';
import {UserDomainsChooserModule} from '../../user-domains/user-domains-chooser/user-domains-chooser.module';



@NgModule({
  declarations: [FieldFormComponent],
  imports: [
    CommonModule,
    DxFormModule,
    UserDomainsChooserModule
  ],
  exports: [FieldFormComponent]
})
export class FieldFormModule { }
